<div class="alert-box" (appClickOutside)="toggleDropdown()">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="onCancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ text.length ? ("ai_modal_title_1" | translate) : ("ai_modal_title_2" | translate) }}
        </h4>
    </div>

    <div class="modal-body static-text-editor-toolbar-wrapper js-click-outside-anchor">
        <div *ngIf="errorMessage?.length" class="alert alert-danger">
            <span>{{ errorMessage }}</span>
        </div>

        <p class="modal-description">
            {{ "ai_description" | translate }}<br />
            <a href="https://platform.openai.com/overview" target="_blank"
                >{{ "ai_learn_more" | translate }} <small class="sp-icon icon-outgoing small-xs color-light"></small
            ></a>
        </p>
        <ng-container *ngIf="text.length">
            <div class="text-container" [class.btn-loading]="isLoading$ | async">
                <div id="ai-text" class="html-text text-muted" [innerHTML]="text | spHtmlToText"></div>
                <div class="word-counter text-muted small">
                    {{ "ai_words_number" | translate }} <span>{{ (text | spHtmlToText).split(" ").length }}</span>

                    <div
                        [tooltip]="'ai_copy_text' | translate"
                        placement="top"
                        container="body"
                        triggers="mouseover:mouseleave"
                        class="pull-right copie-btn"
                        [cdkCopyToClipboard]="text | spHtmlToText"
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7 6V14H14V6H7ZM6 4C5.39249 4 5 4.44772 5 5V15C5 15.5523 5.39249 16 6 16H15C15.6075 16 16 15.5523 16 15V5C16 4.44772 15.6075 4 15 4H6Z"
                                fill="#9DB5C4"
                            />
                            <path
                                d="M2 2V10H5V12H1C0.447715 12 0 11.5523 0 11V1C0 0.447715 0.447715 0 1 0H10C10.5523 0 11 0.447715 11 1V4H9V2H2Z"
                                fill="#9DB5C4"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            <ng-container *ngTemplateOutlet="limitInfo"> </ng-container>

            <div class="ai-control-buttons mt-15" *ngIf="isShadowDom">
                <div class="ai-buttons-left" spClickOutside rootClass="modal-body" (clickOutside)="toggleDropdown()">
                    <div dropdown #dropdownImprove class="btn-group" [class.open]="toggles.improveDropdown">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-controls="dropdown-container"
                            (click)="toggleDropdown('improveDropdown')"
                        >
                            <span>{{ "ai_improve_text" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.IMPROVE]">
                                <a (click)="getAiRequest(EAiTextType.IMPROVE, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>

                    <div dropdown #dropdownTone class="btn-group" [class.open]="toggles.toneDropdown">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-controls="dropdown-container"
                            (click)="toggleDropdown('toneDropdown')"
                        >
                            <span>{{ "ai_change_tone" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.TONE]">
                                <a (click)="getAiRequest(EAiTextType.TONE, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>

                    <div dropdown #dropdownTranslate class="btn-group" [class.open]="toggles.langDropdown">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            [attr.aria-expanded]="toggles.langDropdown"
                            aria-controls="dropdown-container"
                            (click)="toggleDropdown('langDropdown')"
                        >
                            <span>{{ "ai_translate" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.LANG]">
                                <a (click)="getAiRequest(EAiTextType.LANG, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="ai-buttons-right">
                    <button
                        class="btn btn-action"
                        [tooltip]="'ai_try_one_more' | translate"
                        placement="top"
                        (click)="getAiRequest(EAiTextType.REPEAT)"
                    >
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.95 8.64577C14.8742 8.46308 14.746 8.30695 14.5816 8.19713C14.4171 8.0873 14.2238 8.02871 14.026 8.02876H13.026C13.0295 6.70514 12.5961 5.41735 11.7931 4.36513C10.9901 3.3129 9.86236 2.55504 8.58475 2.20906C7.30714 1.86308 5.95107 1.94831 4.72685 2.45155C3.50263 2.9548 2.47866 3.84792 1.81375 4.99241C1.14884 6.13691 0.880143 7.46883 1.04933 8.7816C1.21853 10.0944 1.81615 11.3146 2.74952 12.2531C3.68289 13.1916 4.89985 13.796 6.21167 13.9724C7.52349 14.1488 8.85686 13.8874 10.005 13.2288L8.49699 11.7388C7.70116 12.0535 6.82537 12.1047 5.9983 11.8848C5.17122 11.6649 4.43648 11.1856 3.902 10.5172C3.36753 9.84881 3.06151 9.02664 3.0289 8.17146C2.9963 7.31628 3.23883 6.47317 3.72086 5.76604C4.2029 5.0589 4.89902 4.52502 5.70695 4.24281C6.51488 3.9606 7.39202 3.94495 8.2095 4.19816C9.02699 4.45138 9.74171 4.96009 10.2487 5.64958C10.7556 6.33907 11.0281 7.17296 11.026 8.02876H10.026C9.82824 8.0288 9.63494 8.08749 9.47053 8.19737C9.30612 8.30726 9.17798 8.4634 9.10231 8.6461C9.02664 8.8288 9.00684 9.02985 9.04541 9.2238C9.08397 9.41775 9.17918 9.59591 9.31899 9.73576L11.319 11.7358C11.5065 11.9232 11.7608 12.0285 12.026 12.0285C12.2912 12.0285 12.5455 11.9232 12.733 11.7358L14.733 9.73576C14.8729 9.59592 14.9682 9.4177 15.0069 9.22368C15.0455 9.02965 15.0257 8.82854 14.95 8.64577V8.64577Z"
                                fill="#9DB5C4"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            <div class="ai-control-buttons mt-15" *ngIf="!isShadowDom">
                <div class="ai-buttons-left">
                    <div dropdown class="btn-group">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-controls="dropdown-container"
                        >
                            <span>{{ "ai_improve_text" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.IMPROVE]">
                                <a (click)="getAiRequest(EAiTextType.IMPROVE, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>

                    <div dropdown class="btn-group">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-controls="dropdown-container"
                        >
                            <span>{{ "ai_change_tone" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.TONE]">
                                <a (click)="getAiRequest(EAiTextType.TONE, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>

                    <div dropdown class="btn-group">
                        <button
                            [disabled]="isLoading$ | async"
                            type="button"
                            class="btn btn-action dropdown-toggle"
                            dropdownToggle
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-controls="dropdown-container"
                        >
                            <span>{{ "ai_translate" | translate }}</span>
                            <span class="caret" style="margin-left: 5px"></span>
                        </button>
                        <ul id="dropdown-container" class="dropdown-menu" *dropdownMenu>
                            <li *ngFor="let opt of aiTextMap[EAiTextType.LANG]">
                                <a (click)="getAiRequest(EAiTextType.LANG, opt.label)">{{ opt.text | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="ai-buttons-right">
                    <button
                        class="btn btn-action"
                        [tooltip]="'ai_try_one_more' | translate"
                        placement="top"
                        container="body"
                        triggers="mouseover:mouseleave"
                        (click)="getAiRequest(EAiTextType.REPEAT)"
                    >
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.95 8.64577C14.8742 8.46308 14.746 8.30695 14.5816 8.19713C14.4171 8.0873 14.2238 8.02871 14.026 8.02876H13.026C13.0295 6.70514 12.5961 5.41735 11.7931 4.36513C10.9901 3.3129 9.86236 2.55504 8.58475 2.20906C7.30714 1.86308 5.95107 1.94831 4.72685 2.45155C3.50263 2.9548 2.47866 3.84792 1.81375 4.99241C1.14884 6.13691 0.880143 7.46883 1.04933 8.7816C1.21853 10.0944 1.81615 11.3146 2.74952 12.2531C3.68289 13.1916 4.89985 13.796 6.21167 13.9724C7.52349 14.1488 8.85686 13.8874 10.005 13.2288L8.49699 11.7388C7.70116 12.0535 6.82537 12.1047 5.9983 11.8848C5.17122 11.6649 4.43648 11.1856 3.902 10.5172C3.36753 9.84881 3.06151 9.02664 3.0289 8.17146C2.9963 7.31628 3.23883 6.47317 3.72086 5.76604C4.2029 5.0589 4.89902 4.52502 5.70695 4.24281C6.51488 3.9606 7.39202 3.94495 8.2095 4.19816C9.02699 4.45138 9.74171 4.96009 10.2487 5.64958C10.7556 6.33907 11.0281 7.17296 11.026 8.02876H10.026C9.82824 8.0288 9.63494 8.08749 9.47053 8.19737C9.30612 8.30726 9.17798 8.4634 9.10231 8.6461C9.02664 8.8288 9.00684 9.02985 9.04541 9.2238C9.08397 9.41775 9.17918 9.59591 9.31899 9.73576L11.319 11.7358C11.5065 11.9232 11.7608 12.0285 12.026 12.0285C12.2912 12.0285 12.5455 11.9232 12.733 11.7358L14.733 9.73576C14.8729 9.59592 14.9682 9.4177 15.0069 9.22368C15.0455 9.02965 15.0257 8.82854 14.95 8.64577V8.64577Z"
                                fill="#9DB5C4"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="!text.length">
            <div class="row">
                <div class="col-xs-12">
                    <label>{{ "ai_describe_your_text" | translate }}</label>
                </div>
                <div class="col-xs-12" [class.btn-loading]="isLoading$ | async">
                    <textarea
                        class="form-control"
                        [formControl]="userPromptText"
                        [placeholder]="'ai_describe_your_text_example' | translate"
                    ></textarea>
                </div>
                <div class="col-xs-12">
                    <ng-container *ngTemplateOutlet="limitInfo"> </ng-container>
                </div>
            </div>
        </ng-container>

        <ng-template #limitInfo>
            <ng-container *ngIf="freeKeyUsage && freeKeyLimit">
                <p class="text-muted help-block">
                    {{ "ai_free_request_number" | translate: { FREE_KEY: freeKeyUsage, FREE_KEY_LIMIT: freeKeyLimit } }}
                    <small [tooltip]="'ai_request_limit_info' | translate" class="sp-icon icon-info-bold color-light">
                    </small>
                </p>
            </ng-container>
        </ng-template>
    </div>

    <div class="modal-footer">
        <button class="btn btn-default" type="button" [disabled]="isLoading$ | async" (click)="onCancel()">
            {{ "cancel" | translate }}
        </button>
        <button
            class="btn btn-default ai-btn ml-10"
            type="button"
            [disabled]="(!userPromptText.value?.length && !text.length) || (isLoading$ | async)"
            (click)="onCreateNewText()"
        >
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.4507 3.19666L13.055 4.59107L10.363 1.98394L11.7999 0.548313C12.1516 0.197122 12.6284 -8.7793e-05 13.1256 2.93196e-08C13.6228 8.78516e-05 14.0996 0.197512 14.4511 0.548828C14.8026 0.900144 15.0001 1.37654 15 1.87329C14.9999 2.37003 14.8023 2.84644 14.4507 3.19763V3.19666ZM12.2377 5.40769L3.65555 13.981L0 14.9971L1.002 11.3327L9.55131 2.79209L12.2377 5.40769Z"
                    fill="#583994"
                />
                <path
                    d="M12.5 10L13.1752 11.8248L15 12.5L13.1752 13.1752L12.5 15L11.8248 13.1752L10 12.5L11.8248 11.8248L12.5 10Z"
                    fill="#583994"
                />
                <path
                    d="M3 0L3.81027 2.18973L6 3L3.81027 3.81027L3 6L2.18973 3.81027L0 3L2.18973 2.18973L3 0Z"
                    fill="#583994"
                />
            </svg>

            {{ text.length ? ("ai_new_request" | translate) : ("ai_create_text" | translate) }}
        </button>
        <button
            *ngIf="text.length"
            type="button"
            class="btn btn-primary ml-10"
            [disabled]="isLoading$ | async"
            (click)="onConfirm()"
        >
            {{ "ai_apply_text" | translate }}
        </button>
    </div>
    <div class="modal-footer-info">
        <span class="sp-icon icon-info"> </span>{{ "ai_generated_disclaimer" | translate }}
    </div>
</div>
